import { Login, Logout, GetInfo } from '@/http/api'
import { generatekey } from '@/utils/rsaEncrypt'

const state = {
  token: '',
  casual: '',
  userInfo: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_CASUAL: (state, casual) => {
    state.casual = casual
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  }

}
const actions = {
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    const casual = generatekey(64)
    return new Promise((resolve, reject) => {
      // Login({ userId: username.trim(), userPwd: password, casual: casual }).then(response => {
      Login({ dlzh: username.trim(), dlmm: password, casual: casual }).then(response => {
        const { data } = response
        if (data) {
          commit('SET_TOKEN', data.token)
          commit('SET_CASUAL', casual)
          sessionStorage.setItem('token', data.token)
          sessionStorage.setItem('Authorization', data.token)
          sessionStorage.setItem('casual', casual)

        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      GetInfo().then(response => {
        const { data } = response

        if (!data) {
          reject('验证失败, 请重新登陆了！')
        }

        commit('SET_USERINFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      Logout().then(() => {
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('Authorization')
        sessionStorage.removeItem('casual')
        location.reload()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_CASUAL', [])
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('Authorization')
      sessionStorage.removeItem('casual')
      resolve()
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
